import {GoogleExtensionIcon, Windows} from '@blesk-frontend/ui';
import {ComponentProps} from 'react';
import {useAppPlatform} from '@/hooks';
import {downloadAgent} from '@/libs';
import {GuideZeroCard} from './GuideZeroCard/GuideZeroCard';

export const GuidesZeroState = () => {
  const {windowsStatus, extensionStatus} = useAppPlatform();
  const isNotAvailableWindows = windowsStatus === 'not-available';
  const isNotAvailableExtension = extensionStatus === 'not-available';

  const onClickDownload = (
    platformType: Parameters<ComponentProps<typeof GuideZeroCard>['onClickDownload']>[0],
  ) => {
    if (
      (isNotAvailableWindows && platformType === 'windows') ||
      (isNotAvailableExtension && platformType === 'chrome')
    )
      return;

    downloadAgent(platformType);
  };

  return (
    <div className="mx-auto flex size-full flex-col items-center justify-center gap-8">
      <div>
        <h1 className="mb-3 text-center text-title-h1">Добро пожаловать в Блеск</h1>
        <p className="max-w-xl text-center text-paragraph-md text-text-secondary">
          Чтобы записывать действия на&nbsp;сайтах или&nbsp;приложениях и&nbsp;автоматически
          создавать пошаговые инструкции, вам&nbsp;необходимо установить расширение
          для&nbsp;браузера или&nbsp;приложение для&nbsp;Windows
        </p>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <GuideZeroCard
          platformType="chrome"
          icon={<GoogleExtensionIcon />}
          title="Инструкции для сайтов"
          paragraph={
            'Установите расширение для\u00A0браузера,\nчтобы записывать пошаговые инструкции для\u00A0сайтов.\nНапример для\u00A0Битрикс24, Мой Склад, Jira и\u00A0др.'
          }
          buttonName="Установить Блеск для браузера"
          additionalInfo="Работает в Chrome, Edge, Opera"
          onClickDownload={onClickDownload}
          disabledButton={isNotAvailableExtension}
        />
        <GuideZeroCard
          platformType="windows"
          icon={<Windows className="size-16" />}
          title="Инструкции для приложений"
          paragraph={
            'Установите Блеск для\u00A0Windows,\nчтобы записывать инструкции для\u00A0приложений.\nНапример для\u00A01С:Бухгалтерия, MS Office и\u00A0др.'
          }
          buttonName="Установить Блеск для Windows"
          additionalInfo="Работает в Windows 10 и новее"
          onClickDownload={onClickDownload}
          disabledButton={isNotAvailableWindows}
        />
      </div>
    </div>
  );
};
